// 같은 묶음 소리의 동시 시작 제한(순수 로직). 묶음마다 최근 시작 시각을 고정 크기 고리 버퍼로 들고 있다.

export class VoiceLimiter {
  private readonly times: Float64Array[];
  private readonly heads: Int32Array;
  private readonly windows: Float64Array;

  constructor(limits: readonly { max: number; window: number }[]) {
    this.times = limits.map((l) => new Float64Array(Math.max(1, l.max)).fill(-Infinity));
    this.heads = new Int32Array(limits.length);
    this.windows = Float64Array.from(limits.map((l) => l.window));
  }

  /** now(초)에 group 소리를 시작해도 되면 기록하고 true. window 안에 이미 max개가 시작했으면 false. */
  allow(group: number, now: number): boolean {
    const t = this.times[group];
    const h = this.heads[group];
    // 고리 버퍼의 가장 오래된 시작이 아직 창 안이면 꽉 찬 것이다
    if (now - t[h] < this.windows[group]) return false;
    t[h] = now;
    this.heads[group] = (h + 1) % t.length;
    return true;
  }

  reset(): void {
    for (const t of this.times) t.fill(-Infinity);
    this.heads.fill(0);
  }
}
